export default function useAbsoluteUrl() {
  const { siteUrl } = useRuntimeConfig().public
  const route = useRoute()
  return join(siteUrl, route.path)
}
